import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Settings from './pages/settings';
import ContactDetailsPage from './pages/contact-details';
import LoginPage from './pages/login';
import RandomContactPage from './pages/random-contact';
import MessageTemplates from './pages/message-templates';
import Dashboard from './pages/dashboard';
import AddEditContact from './pages/add-edit-contact';
import BirthdayCalendar from './pages/birthday-calendar';
import ContactList from './pages/contact-list';
import MessageHistory from './pages/message-history';
import Register from './pages/register';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AddEditContact />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/contact-details" element={<ContactDetailsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/random-contact" element={<RandomContactPage />} />
        <Route path="/message-templates" element={<MessageTemplates />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/add-edit-contact" element={<AddEditContact />} />
        <Route path="/birthday-calendar" element={<BirthdayCalendar />} />
        <Route path="/contact-list" element={<ContactList />} />
        <Route path="/message-history" element={<MessageHistory />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
